import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/newsCategory';
const new_category_Api = {
	get: (params) => {
		return axiosClient.get(url + '/admin', { params });
	},
	update: (id, body) => {
		return axiosClient.put(url + `/${id}`, body);
	},
	create: (body) => {
		return axiosClient.post(url, body);
	},
	delete: (id) => {
		return axiosClient.delete(url + `/${id}`);
	},
};
export default new_category_Api;
